// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-tree/~/rc-animate/lib/index.js
 ** module id = 527
 ** module chunks = 0
 **/